import React, {
  useCallback,
  useEffect,
  useReducer, useState,
} from 'react';
import { Carousel } from './Carousel';
import { Filter } from './Filter';
import { List } from './List';

import styles from './styles.module.scss';
import { HOST } from '../../constants/api';

const imgReducerInitial = {
  images: [],
  fetching: false,
  total: 12,
  collectionName: 'punks',
  collectionNumber: null,
  sort: { by: null, order: '' },
};

const imgReducer = (state, action) => {
  switch (action.type) {
    case 'SET_IMAGES':
      return {
        ...state,
        images: action.images,
        total: action.total,
        fetching: action.fetching,
      };
    case 'STACK_IMAGES':
      return {
        ...state,
        images: state.images.concat(action.images),
        total: action.total,
        fetching: action.fetching,
      };
    case 'FETCHING_IMAGES':
      return { ...state, fetching: action.fetching };
    case 'SET_COLLECTION':
      return {
        ...imgReducerInitial,
        images: [],
        collectionName: action.name,
        collectionNumber: action.number,
      };
    case 'SET_SORT':
      return {
        ...state,
        sort: action.sort,
      };
    default:
      return state;
  }
};

export const Gallery = () => {
  const [imagesState, imgDispatch] = useReducer(
    imgReducer,
    imgReducerInitial,
  );

  const [search, setSearch] = useState<string>('');

  const handleSort = (type: string | null, order: string) => {
    imgDispatch({ type: 'SET_SORT', sort: { by: type, order } });
  };

  const getImages = useCallback((isStackImage?: boolean) => {
    imgDispatch({ type: 'FETCHING_IMAGES', fetching: true });
    const offset = isStackImage ? imagesState.images.length : 0;
    let limit = 12;
    if (isStackImage && offset + limit >= imagesState.total) limit = imagesState.total - offset;
    // eslint-disable-next-line max-len
    fetch(`${HOST}/${imagesState.collectionName}?limit=${limit}&offset=${offset}&sort_by=${
      imagesState.sort.by}&order=${imagesState.sort.order}&index=${search}${
      typeof imagesState.collectionNumber === 'number' ?
        `&collection=${imagesState.collectionNumber}` :
        ''}`)
      .then((data) => data.json())
      .then((imagesResult) => {
        imgDispatch({
          type: isStackImage ? 'STACK_IMAGES' : 'SET_IMAGES',
          images: imagesResult[imagesState.collectionName],
          fetching: false,
          total: imagesResult.total || imagesState.total,
        });
      })
      .catch((e) => {
        imgDispatch({ type: 'FETCHING_IMAGES', fetching: false });
        return e;
      });
  }, [imagesState, search]);

  useEffect(() => {
    getImages();
  }, [imagesState.collectionName, imagesState.collectionNumber, imagesState.sort, search]);

  return (
    <div className={styles.container}>
      <Carousel
        afterChange={async (current) => {
          if (search) {
            await setSearch('');
          }

          await imgDispatch({ type: 'SET_SORT', sort: { by: null, order: '' } });
          if (current === 1 && imagesState.collectionNumber === null) return;
          if (current === 0 && imagesState.collectionNumber === 1) return;
          if (current === 2 && imagesState.collectionNumber === 2) return;

          if (current === 0 || current === 2) {
            imgDispatch({ type: 'SET_COLLECTION', name: 'cars', number: !current ? 1 : 2 });
            return;
          }
          imgDispatch({ type: 'SET_COLLECTION', name: 'punks', number: null });
        }}
      />
      <Filter
        onSortById={(sort) => handleSort(sort ? 'index' : null, sort)}
        onSortByRank={(sort) => handleSort(sort ? 'rank' : null, sort)}
        type={imagesState.collectionName}
        search={search}
        setSearch={setSearch}
      />
      <List
        getImages={getImages}
        images={imagesState.images}
        total={imagesState.total}
        collection={{ name: imagesState.collectionName, number: imagesState.collectionNumber }}
      />
    </div>
  );
};
